var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconProjectorScreen = function SvgIconProjectorScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 17.5a1 1 0 1 1 0-2h.5V8.482A1.75 1.75 0 0 1 2 6.75V4.5c0-.966.784-1.75 1.75-1.75h16.5c.966 0 1.75.784 1.75 1.75v2.25a1.75 1.75 0 0 1-1.5 1.732V15.5h.5a1 1 0 1 1 0 2h-8v4.25a1 1 0 1 1-2 0V17.5zm1-11V4.75h16V6.5zm1.5 9h13v-7h-13z",
    clipRule: "evenodd"
  })));
};
export default SvgIconProjectorScreen;